import React from "react";
import Query from "../Query";
import { Link } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

import mainLogo from'../../img/logo.png';

import CATEGORIES_QUERY from "../../queries/category/categories";

function MyNav() {
   return(
    <Query query={CATEGORIES_QUERY} id={null}>
      {({ data: { categories } }) => {
        return (
          <Navbar expand="xl">
            <Container fluid>
              <Navbar.Brand href="/"><img src={mainLogo} alt="Fahrschule Bergedorf"/></Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className='icon'></span>
              </Navbar.Toggle>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  <NavDropdown show title="Führerscheine" align="start" id="basic-nav-dropdown" className="text-uppercase" onClick={()=> window.open("/fuehrerscheine/", "_top")}>
                    {categories.data.slice(0, 6).map((category) => {
                        return (
                          <NavDropdown.Item as="div" key={category.attributes.slug}>
                            <Link
                              to={`/fuehrerscheine/${category.attributes.slug}`}
                              className="dropdown-link"
                              target="_top" 
                              rel="noopener noreferrer"
                            >
                              {category.attributes.title}
                            </Link>
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                    <Nav.Item>
                    <Nav.Link href="/erste-hilfe">ERSTE HILFE</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link href="/team">ÜBER UNS</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link href="/kontakt">KONTAKT</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        );
      }}
    </Query>
  )
}

export default MyNav;

function initNavbarРideWhileScrolling() {
  const nav = document.querySelector('.navbar');
  const navnotscroll = document.querySelector('.navbar-toggler');

  if (!nav) return;

  let scrollPrev = 0;
  window.addEventListener("scroll", function () {
      const scrolled = window.pageYOffset;

      const scrollDown = (scrolled > 100 && scrolled > scrollPrev)

      if(navnotscroll.classList.contains('collapsed')){
        if (scrollDown) {
          nav.classList.add('out');
        }
       
  
        if (!scrollDown && nav.classList.contains('out')) {
            nav.classList.remove('out');
        }
      }

      

      scrollPrev = scrolled;
  });

}

window.addEventListener('load', ()=>{
  setTimeout(() => {
    initNavbarРideWhileScrolling();
  }, 1000)
});